module.exports = __webpack_public_path__ + "static/pech-ser-8e0ec938a29c63062d3ea93262771039.webp";